"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLitium = exports.injectionKeys = exports.search = exports.products = exports.sales = exports.websites = exports.batch = exports.query = exports.request = exports.configure = exports.plugin = void 0;
var tslib_1 = require("tslib");
var plugin_1 = require("./plugin");
Object.defineProperty(exports, "plugin", { enumerable: true, get: function () { return plugin_1.plugin; } });
var receivers_1 = require("./receivers");
Object.defineProperty(exports, "configure", { enumerable: true, get: function () { return receivers_1.configure; } });
Object.defineProperty(exports, "request", { enumerable: true, get: function () { return receivers_1.request; } });
Object.defineProperty(exports, "query", { enumerable: true, get: function () { return receivers_1.query; } });
exports.batch = tslib_1.__importStar(require("./receivers/batch-query"));
exports.websites = tslib_1.__importStar(require("./receivers/websites"));
exports.sales = tslib_1.__importStar(require("./receivers/sales"));
exports.products = tslib_1.__importStar(require("./receivers/products"));
/** Integration for Distancify.LitiumAddOns.Elasticsearch */
exports.search = tslib_1.__importStar(require("./receivers/search"));
exports.injectionKeys = tslib_1.__importStar(require("./keys"));
var withLitium_1 = tslib_1.__importDefault(require("./composables/withLitium"));
function withLitium() {
    return (0, withLitium_1.default)();
}
exports.withLitium = withLitium;
;
//# sourceMappingURL=index.js.map